import React from "react";
import "./styles.css";

const CardReasonComponent = ({
  dermaReasonListVisible,
  esteticaReasonListVisible,
  plasticaReasonListVisible,
  capilarReasonListVisible,
  dermatologiaReasonList,
  esteticaReasonList,
  plasticaReasonList,
  capilarReasonList,
  modalityAndSpecialtySelected,
}) => {
  const onClick = (reason, codeModality) => {
    modalityAndSpecialtySelected(reason, codeModality);
  };

  return (
    <div className="containerCardReason">
      {dermaReasonListVisible && (
        <div className="reasonList">
          {dermatologiaReasonList.map((reason) => (
            <div
              className="reasonCardReason"
              key={reason.id}
              onClick={() => onClick(reason, "01")}
            >
              <div className="avatarColumnCardReason">
                <p className="avatarTextCardReason">{reason.avatar}</p>
              </div>
              <div className="infoColumnCardReason">
                <div className="reasonCardTitle">{reason.title}</div>
                <div className="reasonCardSubtitle">{reason.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {esteticaReasonListVisible && (
        <div className="reasonList">
          {esteticaReasonList.map((reason) => (
            <div
              className="reasonCardReason"
              key={reason.id}
              onClick={() => onClick(reason, "02")}
            >
              <div className="avatarColumnCardReason">
                <p className="avatarTextCardReason">{reason.avatar}</p>
              </div>
              <div className="infoColumnCardReason">
                <div className="reasonCardTitle">{reason.title}</div>
                <div className="reasonCardSubtitle">{reason.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {plasticaReasonListVisible && (
        <div className="reasonList">
          {plasticaReasonList.map((reason) => (
            <div
              className="reasonCardReason"
              key={reason.id}
              onClick={() => onClick(reason, "04")}
            >
              <div className="avatarColumnCardReason">
                <p className="avatarTextCardReason">{reason.avatar}</p>
              </div>
              <div className="infoColumnCardReason">
                <div className="reasonCardTitle">{reason.title}</div>
                <div className="reasonCardSubtitle">{reason.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {capilarReasonListVisible && (
        <div className="reasonList">
          {capilarReasonList.map((reason) => (
            <div
              className="reasonCardReason"
              key={reason.id}
              onClick={() => onClick(reason, "06")}
            >
              <div className="avatarColumnCardReason">
                <p className="avatarTextCardReason">{reason.avatar}</p>
              </div>
              <div className="infoColumnCardReason">
                <div className="reasonCardTitle">{reason.title}</div>
                <div className="reasonCardSubtitle">{reason.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CardReasonComponent;
